import { useCallback } from 'react'
import { AnimatePresence } from 'motion/react'
import { UIElement } from '../../types/UIElements'
import { useContextPanels } from '../../contexts/panelsContext'
import { useContextMotifDetails } from '../../contexts/motifDetailsContext'
import KeywordsFilterOverlay from './KeywordsFilterOverlay'

const KeywordsFilter = () => {
  const { isPanelOpen, hideOverlay, closeAll } = useContextPanels()
  const { applyKeywordFilter } = useContextMotifDetails()

  const close = () => {
    hideOverlay()
    window.history.replaceState(null, '', '/')
    closeAll()
    applyKeywordFilter(undefined)
  }

  // Stable identity so the memoized keyword columns/buttons don't re-render
  const selectKeyword = useCallback(
    (keywordId: number) => {
      applyKeywordFilter(keywordId)
      hideOverlay()
      window.history.replaceState(null, '', '/')
      closeAll()
    },
    [applyKeywordFilter, hideOverlay, closeAll],
  )

  return (
    <AnimatePresence>
      {isPanelOpen(UIElement.KEYWORDFILTER) ? (
        <KeywordsFilterOverlay
          key="keywords-filter"
          onSelectKeyword={selectKeyword}
          onClose={close}
        />
      ) : null}
    </AnimatePresence>
  )
}

export default KeywordsFilter
